'use client'
import { Box } from '@chakra-ui/react'
import { useAuthInfo } from '@propelauth/react'
import { postStoreData } from '@web/client/store'
import { ColorPaletteSection } from '@web/components/ColorPalette/ColorPaletteSection'
import { getOrgName } from '@web/context'
import useMirrorfulStore, { MirrorfulState } from '@web/store/useMirrorfulStore'
import { TTokenGroup } from '@web/types'

export default function ColorsPage() {
  const authInfo = useAuthInfo()
  const CONTEXT_STORE_ID = `${getOrgName({ authInfo })}-prod`

  const {
    colors,
    typography,
    shadows,
    fileTypes,
    setColors,
    themes,
    metadata,
  } = useMirrorfulStore((state: MirrorfulState) => state)

  const handleUpdateColors = async (data: TTokenGroup) => {
    setColors(data)

    await postStoreData({
      newData: {
        primitives: {
          colors: data,
          typography,
          shadows,
        },
        themes,
        files: fileTypes,
        metadata,
      },
      authInfo: authInfo,
    })
  }
  return (
    <Box
      css={{
        padding: 'var(--padding-y) var(--gutter-x)',
      }}
    >
      <ColorPaletteSection
        colors={colors}
        onUpdateColors={handleUpdateColors}
      />
    </Box>
  )
}
